<div class="list-item-limited-width">
    <core-dynamic-component [component]="componentClass" [data]="data" />
</div>
